<template>
<div class="oido-modal">
  <slot></slot>
</div>  
</template>


<script >



export default {

  

}
</script>


<style scoped>
.oido-modal{
  display: flex;
  flex-direction: column;
  height: 100%;
}

.android  .oido-modal{
  padding-top: var(--safe-area-inset-top, env(safe-area-inset-top, 0px));
}

</style>
<style>
.teleport .oido-modal{
  height: auto;
}

</style>

